// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   Button,
//   Grid,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Box,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
//   DirectionsCar as CarIcon,
//   Email as EmailIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import { gridSpacing } from "store/constant";
// import MainCard from "ui-component/cards/MainCard";
// import { useDebounce } from "hooks/useDebounced";

// export default function EntryApprovalList() {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});
//   const [downloading, setDownloading] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // Fetch entry approvals
//   const fetchEntryApprovals = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}entry-approval-list?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();
//       if (result.code === 200) {
//         setRows(result.data.entryApprovals || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch entry approvals");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching entry approvals:", error);
//       toast.error("Something went wrong while fetching entry approvals");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEntryApprovals();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // Update status
//   const updateEntryApprovalStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;
//     const actionText = newStatus === "accept" ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this entry approval?`,
//       icon: newStatus === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === "reject",
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}update-entry-approval-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success(`Entry approval ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} entry`);
//         }
//       } catch (error) {
//         console.error("Error updating entry status:", error);
//         toast.error("Something went wrong while updating status");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // Send gate pass
//   const sendGatePass = async (id, name) => {
//     setSendingPass(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}send-entry-gate-pass/${id}`, {
//         method: "POST",
//         headers: {
//           authkey: process.env.REACT_APP_AUTH_KEY,
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json",
//         },
//       });
//       const result = await response.json();

//       if (result.code === 200) {
//         toast.success(`Gate pass sent successfully to ${name}`);
//       } else {
//         toast.error(result.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       console.error("Error sending gate pass:", error);
//       toast.error("Something went wrong while sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   const handleDownload = async (id, employeeId) => {
//     if (downloading[id]) return;

//     setDownloading((prev) => ({ ...prev, [id]: true }));

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/download-gatepass-entry/${id}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Download failed:", errorText);
//         toast.error("Failed to download gate pass");
//         return;
//       }

//       // ✅ Check if response has content
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/pdf")) {
//         console.error("Invalid content type:", contentType);
//         toast.error("Invalid PDF response");
//         return;
//       }

//       const blob = await response.blob();

//       // ✅ Verify blob has content
//       if (blob.size === 0) {
//         console.error("Empty PDF received");
//         toast.error("Empty PDF file");
//         return;
//       }

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `GatePass_${employeeId}.pdf`;
//       document.body.appendChild(a);
//       a.click();

//       // ✅ Cleanup after a short delay
//       setTimeout(() => {
//         window.URL.revokeObjectURL(url);
//         document.body.removeChild(a);
//         toast.success("Gate pass downloaded successfully");
//       }, 100);
//     } catch (error) {
//       console.error("Error downloading gate pass:", error);
//       toast.error("Something went wrong while downloading gate pass");
//     } finally {
//       setDownloading((prev) => ({ ...prev, [id]: false }));
//     }
//   };

//   // Delete entry approval
//   const deleteEntryApproval = (id, name) => {
//     swal({
//       title: `Delete ${name}?`,
//       text: "This will permanently delete this entry approval record!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     }).then(async (willDelete) => {
//       if (!willDelete) return;

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/delete-entry-approval/${id}`,
//           {
//             method: "DELETE",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success("Entry approval deleted successfully");
//           setRows((prev) => prev.filter((item) => item._id !== id));
//           setTotal((prev) => prev - 1);
//         } else {
//           toast.error(result.message || "Failed to delete entry approval");
//         }
//       } catch (error) {
//         console.error("Error deleting entry approval:", error);
//         toast.error("Something went wrong while deleting entry approval");
//       }
//     });
//   };

//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search entry approvals..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Name, email, mobile, company..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">
//                 After Office Hours Entry Approval Form ({total} total)
//               </Typography>
//             </Grid>
//             <Grid item>
//               {/* <Button
//                                 variant="contained"
//                                 onClick={() => navigate("/add-entry-approval")}
//                                 startIcon={<AddIcon />}
//                             >
//                                 Add Entry Approval
//                             </Button> */}
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="entry approval table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>Employee ID</TableCell>
//                     <TableCell>Name</TableCell>
//                     <TableCell>Department</TableCell>
//                     <TableCell>Contact</TableCell>
//                     <TableCell>Visit Period</TableCell>
//                     <TableCell>HOD Status</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={9} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={9} align="center">
//                         <Typography>No entry approvals found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold" color="primary">
//                             {row.employeeId}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold">
//                             {row.fullName}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{row.department}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{row.mobile}</Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             {row.email}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="caption" display="block">
//                             From: {formatDate(row.visitStart)}
//                           </Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             To: {formatDate(row.visitEnd)}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell>{getStatusChip(row.status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             <Tooltip title="View Details">
//                               <IconButton
//                                 size="small"
//                                 color="info"
//                                 onClick={() => navigate(`/entry-approval/${row._id}`)}
//                               >
//                                 <ViewIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>

//                             {row.status === "pending" && (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateEntryApprovalStatus(row._id, "accept", row.fullName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateEntryApprovalStatus(row._id, "reject", row.fullName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             {row.status === "accept" && (
//                               <>
//                                 <Tooltip title="Send Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() => sendGatePass(row._id, row.fullName)}
//                                     disabled={sendingPass}
//                                   >
//                                     <EmailIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Download Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="secondary"
//                                     onClick={() => handleDownload(row._id, row.employeeId)}
//                                     disabled={!!downloading[row._id]}
//                                   >
//                                     {downloading[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <DownloadIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             <Tooltip title="Delete">
//                               <IconButton
//                                 size="small"
//                                 color="error"
//                                 onClick={() => deleteEntryApproval(row._id, row.fullName)}
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }

import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  TextField,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
  Email as EmailIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { gridSpacing, PASS_STATUS } from "store/constant";
import MainCard from "ui-component/cards/MainCard";
import { useDebounce } from "hooks/useDebounced";
import { useTranslation } from "react-i18next";

export default function EntryApprovalList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});
  const [downloading, setDownloading] = useState({});
  const debouncedSearch = useDebounce(search, 1000);

  const fetchEntryApprovals = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}entry-approval-list?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();
      if (result.code === 200) {
        setRows(result.data.entryApprovals || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("EntryApproval.fetchError"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error(error);
      toast.error(t("EntryApproval.fetchError"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntryApprovals();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // const updateEntryApprovalStatus = async (id, newStatus, name) => {
  //   if (updatingStatus[id]) return;
  //   const actionText =
  //     newStatus === "accept" ? t("EntryApproval.accept") : t("EntryApproval.reject");

  //   swal({
  //     title: `${actionText} ${name}?`,
  //     text: t("EntryApproval.confirmStatus", { action: actionText.toLowerCase() }),
  //     icon: newStatus === "accept" ? "success" : "error",
  //     buttons: [t("EntryApproval.cancel"), actionText],
  //     dangerMode: newStatus === "reject",
  //   }).then(async (willProceed) => {
  //     if (!willProceed) return;

  //     try {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: true }));
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}update-entry-approval-status/${id}`,
  //         {
  //           method: "PUT",
  //           headers: {
  //             authkey: process.env.REACT_APP_AUTH_KEY,
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ status: newStatus, lang: localStorage.getItem("lang") }),
  //         },
  //       );
  //       const result = await response.json();
  //       if (result.code === 200) {
  //         toast.success(t("EntryApproval.statusUpdated", { action: actionText }));
  //         setRows((prev) =>
  //           prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
  //         );
  //       } else {
  //         toast.error(
  //           result.message || t("EntryApproval.statusUpdateError", { action: actionText }),
  //         );
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       toast.error(t("EntryApproval.statusUpdateError", { action: actionText }));
  //     } finally {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
  //     }
  //   });
  // };

  // const sendGatePass = async (id, name) => {
  //   setSendingPass(true);
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}send-entry-gate-pass/${id}`, {
  //       method: "POST",
  //       headers: {
  //         authkey: process.env.REACT_APP_AUTH_KEY,
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });
  //     const result = await response.json();
  //     if (result.code === 200) {
  //       toast.success(t("EntryApproval.sendSuccess", { name }));
  //     } else {
  //       toast.error(result.message || t("EntryApproval.sendError"));
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.error(t("EntryApproval.sendError"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateEntryApprovalStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("EntryApproval.chooseLanguageTitle"),
      text: t("EntryApproval.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      newStatus === "accept" ? t("EntryApproval.accept") : t("EntryApproval.reject");

    // STEP 2: Confirmation
    const willProceed = await swal({
      title: `${actionText} ${name}?`,
      text: t("EntryApproval.confirmStatus", {
        action: actionText.toLowerCase(),
      }),
      icon: newStatus === "accept" ? "success" : "error",
      buttons: [t("EntryApproval.cancel"), actionText],
      dangerMode: newStatus === "reject",
    });

    if (!willProceed) return;

    try {
      setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}update-entry-approval-status/${id}`,
        {
          method: "PUT",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: newStatus,
            lang: langChoice, // ✅ explicit language
          }),
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        toast.success(t("EntryApproval.statusUpdated", { action: actionText }));

        setRows((prev) =>
          prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
        );
      } else {
        toast.error(
          result.message ||
            t("EntryApproval.statusUpdateError", {
              action: actionText,
            }),
        );
      }
    } catch (error) {
      console.error(error);
      toast.error(t("EntryApproval.statusUpdateError", { action: actionText }));
    } finally {
      setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
    }
  };

  const sendGatePass = async (id, name) => {
    const langChoice = await swal({
      title: t("EntryApproval.chooseLanguageTitle"),
      text: t("EntryApproval.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    setSendingPass(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}send-entry-gate-pass/${id}`, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const result = await response.json();
      if (result.code === 200) {
        toast.success(t("EntryApproval.sendSuccess", { name }));
      } else {
        toast.error(result.message || t("EntryApproval.sendError"));
      }
    } catch (error) {
      console.error(error);
      toast.error(t("EntryApproval.sendError"));
    } finally {
      setSendingPass(false);
    }
  };

  const handleDownload = async (id, employeeId) => {
    const choice = await swal({
      title: t("EntryApproval.downloadOptions.title"),
      text: t("EntryApproval.downloadOptions.text"),
      icon: "info",
      buttons: {
        gatepass: {
          text: t("EntryApproval.downloadOptions.gatePass"),
          value: "gatepass",
        },
        details: {
          text: t("EntryApproval.downloadOptions.details"),
          value: "details",
        },
      },
    });

    if (!choice) return;
    if (downloading[id]) return;

    setDownloading((prev) => ({ ...prev, [id]: true }));

    try {
      let endpoint = "";
      let fileName = "";

      if (choice === "gatepass") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-entry/${id}`;
        fileName = `GatePass_${employeeId}.pdf`;
      } else if (choice === "details") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-entry-details/${id}`;
        fileName = `EntryGatePassDetails_${employeeId}.pdf`;
      } else {
        return;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: localStorage.getItem("lang") }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Download failed:", errorText);
        toast.error(t("EntryApproval.downloadError"));
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        toast.success(t("EntryApproval.downloadSuccess"));
      }, 100);
    } catch (error) {
      console.error("Error downloading gate pass:", error);
      toast.error(t("EntryApproval.downloadError"));
    } finally {
      setDownloading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const deleteEntryApproval = (id, name) => {
    swal({
      title: t("EntryApproval.deleteTitle", { name }),
      text: t("EntryApproval.deleteText"),
      icon: "warning",
      buttons: [t("EntryApproval.cancel"), t("EntryApproval.delete")],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}delete-entry-approval/${id}`,
          {
            method: "DELETE",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const result = await response.json();
        if (result.code === 200) {
          toast.success(t("EntryApproval.deleteSuccess"));
          setRows((prev) => prev.filter((item) => item._id !== id));
          setTotal((prev) => prev - 1);
        } else {
          toast.error(result.message || t("EntryApproval.deleteError"));
        }
      } catch (error) {
        console.error(error);
        toast.error(t("EntryApproval.deleteError"));
      }
    });
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { color: "warning", icon: <PendingIcon />, label: t("EntryApproval.pending") },
      accept: { color: "success", icon: <AcceptIcon />, label: t("EntryApproval.accepted") },
      reject: { color: "error", icon: <RejectIcon />, label: t("EntryApproval.rejected") },
    };
    const config = statusConfig[status] || statusConfig.pending;
    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("EntryApproval.searchLabel")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("EntryApproval.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("EntryApproval.statusFilter")}</InputLabel>
            <Select
              value={statusFilter}
              onChange={handleStatusFilter}
              label={t("EntryApproval.statusFilter")}
            >
              <MenuItem value="all">{t("EntryApproval.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("EntryApproval.pending")}</MenuItem>
              <MenuItem value="accept">{t("EntryApproval.accepted")}</MenuItem>
              <MenuItem value="reject">{t("EntryApproval.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">{t("EntryApproval.title", { total })}</Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="entry approval table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("EntryApproval.sNo")}</TableCell>
                    <TableCell>{t("EntryApproval.employeeId")}</TableCell>
                    <TableCell>{t("EntryApproval.name")}</TableCell>
                    <TableCell>{t("EntryApproval.department")}</TableCell>
                    <TableCell>{t("EntryApproval.contact")}</TableCell>
                    {/* <TableCell>{t("EntryApproval.visitPeriod")}</TableCell> */}
                    <TableCell>{t("EntryApproval.hodStatus")}</TableCell>
                    <TableCell>{t("EntryApproval.status")}</TableCell>
                    <TableCell align="center">{t("EntryApproval.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        {t("EntryApproval.loading")}
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        {t("EntryApproval.noData")}
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold" color="primary">
                            {row.employeeId}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">
                            {row.fullName}
                          </Typography>
                        </TableCell>
                        <TableCell>{row.department.name}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{row.mobile}</Typography>
                          <Typography variant="caption" color="textSecondary">
                            {row.email}
                          </Typography>
                        </TableCell>
                        {/* <TableCell>
                        <Typography variant="caption" display="block">{t("EntryApproval.from")}: {formatDate(row.visitStart)}</Typography>
                        <Typography variant="caption" color="textSecondary">{t("EntryApproval.to")}: {formatDate(row.visitEnd)}</Typography>
                      </TableCell> */}
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell>{getStatusChip(row.status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            <Tooltip title={t("EntryApproval.view")}>
                              <IconButton
                                size="small"
                                color="info"
                                onClick={() => navigate(`/entry-approval/${row._id}`)}
                              >
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {/* {row.status === "pending" || row?.staff_status === "reject" && (
                              <>
                                <Tooltip title={t("EntryApproval.accept")}>
                                  <IconButton
                                    size="small"
                                    color="success"
                                    onClick={() =>
                                      updateEntryApprovalStatus(row._id, "accept", row.fullName)
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    {updatingStatus[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <AcceptIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("EntryApproval.reject")}>
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      updateEntryApprovalStatus(row._id, "reject", row.fullName)
                                    }
                                    disabled={!!updatingStatus[row._id]}
                                  >
                                    <RejectIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )} */}

                            {row.staff_status !== PASS_STATUS.REJECTED &&
                              row.status === PASS_STATUS.PENDING && (
                                <>
                                  <Tooltip title={t("EntryApproval.accept")}>
                                    <IconButton
                                      size="small"
                                      color="success"
                                      onClick={() =>
                                        updateEntryApprovalStatus(
                                          row._id,
                                          "accept",
                                          row.fullName || "Visitor",
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      {updatingStatus[row._id] ? (
                                        <CircularProgress size={16} />
                                      ) : (
                                        <AcceptIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title={t("EntryApproval.reject")}>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        updateEntryApprovalStatus(
                                          row._id,
                                          "reject",
                                          row.fullName || "Visitor",
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      <RejectIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}

                            {row.status === "accept" && (
                              <>
                                <Tooltip title={t("EntryApproval.sendGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => sendGatePass(row._id, row.fullName)}
                                    disabled={sendingPass}
                                  >
                                    <EmailIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("EntryApproval.downloadGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="secondary"
                                    onClick={() => handleDownload(row._id, row.employeeId)}
                                    disabled={!!downloading[row._id]}
                                  >
                                    {downloading[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <DownloadIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                            <Tooltip title={t("EntryApproval.delete")}>
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => deleteEntryApproval(row._id, row.fullName)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}
